import Glide from '@glidejs/glide'
//import { updateFadeSlider } from './slider-utils';


const initBFLifeBlock = () => {
    let block = document.querySelector(".js-block-bflife");


    if (!block) return;
    let gliderRoot = block.querySelector(".glide");
    if (!gliderRoot) return;

    const buttons = block.querySelectorAll(".js-goToButton");
    const texts = block.querySelectorAll(".js-text");
    const textSectionBreaks = []
    texts.forEach((element) => { textSectionBreaks.push(parseInt(element.dataset.start)) })
    texts.forEach((element) => { textSectionBreaks.push(parseInt(element.dataset.end)) })


    let options = {
        type: 'slider',
        perView: 2,
        autoplay: 0,
        animationDuration: 900,
        rewindDuration: 1700,
        swipeThreshold: 40, //default 80, which is a bit too lazy
        dragThreshold: 60, //default 120, which is a bit too lazy
        touchAngle: 30,
        pauseOnHover: true,
        gap: 30,
        breakpoints: {
            1024: {
                gap: 20,
                perView: 1,
                peek: { before: 20, after: 20 }
            },
            640: {
                gap: 20,
                perView: 1,
                peek: { before: 40, after: 40 }
            }
        }


    }

    const glide = new Glide(gliderRoot, options);

    const updateTexts = (desiredState) => {
        if (!texts) return;
        if (texts.length < 1) return;

        if (!textSectionBreaks.includes(desiredState)) return;

        texts.forEach((element) => {
            if (desiredState == element.dataset.start || desiredState == element.dataset.end) {
                element.animate({ opacity: 1 }, { duration: 300 }).onfinish = () => {
                    element.classList.remove("opacity-0");
                    element.classList.add("z-10");
                };
            } else {
                if (element.classList.contains("opacity-0")) return;
                element.animate({ opacity: 0 }, { duration: 500 }).onfinish = () => {
                    element.classList.add("opacity-0");
                    element.classList.remove("z-10");
                };
            }
        });
    }

    //console.log(buttons);
    buttons.forEach((element) => {
        element.addEventListener("click", () => {
            //console.log(i);
            glide.go('=' + parseInt(element.dataset.goto));
        })
    });

    let left = block.querySelectorAll(".js-left");
    let right = block.querySelectorAll(".js-right");
    if (left) {
        left.forEach((element) => {
            element.addEventListener("click", () => { glide.go("<") })
        });

    }
    if (right) {
        right.forEach((element) => {
            element.addEventListener("click", () => { glide.go(">") })
        });
    }

    glide.on('mount.after', function () {
        gliderRoot.classList.add('mounted')
    })

    glide.on('run', (event) => {

        updateTexts(glide.index);

    })

    glide.mount()

}

export { initBFLifeBlock }
